/* table-head.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isRanking", "testId"],
  _excluded2 = ["width", "children", "isSortable", "sortOrder", "isFixedSize", "shouldTruncate", "onClick", "style", "testId"];
import "./table-head.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @repo/internal/react/require-jsdoc */

import { forwardRef } from 'react';
import { ASC, DESC } from '../internal/constants';
import { getTruncationStyleVars } from './constants';
var CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
var rankingStyles = null;
var headStyles = null;
var overflowTruncateStyles = null;
var truncationWidthStyles = null;
var fixedSizeTruncateStyles = null;
var cellStyles = null;
export var Head = function Head(_ref) {
  var isRanking = _ref.isRanking,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("thead", _extends({
    "data-testid": testId
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props, {
    className: ax(["_179rglyw", isRanking && "_1e0c1ule"])
  }));
};
var headCellBaseStyles = null;
export var HeadCell = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var width = _ref2.width,
    children = _ref2.children,
    isSortable = _ref2.isSortable,
    sortOrder = _ref2.sortOrder,
    isFixedSize = _ref2.isFixedSize,
    shouldTruncate = _ref2.shouldTruncate,
    onClick = _ref2.onClick,
    style = _ref2.style,
    testId = _ref2.testId,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var mergedStyles = _objectSpread(_objectSpread(_objectSpread({}, style), width && getTruncationStyleVars({
    width: width
  })), {}, _defineProperty({}, CSS_VAR_TEXT_COLOR, "var(--ds-text-subtlest, #626F86)"));
  var isASC = sortOrder === ASC;
  var isDESC = sortOrder === DESC;
  var getFormattedSortOrder = function getFormattedSortOrder() {
    if (isASC) {
      return 'ascending';
    } else if (isDESC) {
      return 'descending';
    }
  };

  // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
  // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
  var Component = children ? 'th' : 'td';
  return /*#__PURE__*/React.createElement(Component, _extends({
    "aria-sort": getFormattedSortOrder()
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,

    onClick: undefined,
    ref: ref,
    "data-testid": testId
  }, rest, {
    className: ax(["_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t", "_11c8dcr7 _179r187z _mqm2glyw _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4nkob _1ygbi3bv", "_1bsb8a2a", isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c", isFixedSize && "_1reo15vq _18m915vq"]),
    style: _objectSpread(_objectSpread({}, mergedStyles), {}, {
      "--_17ckjys": ix("var(--ds-text-subtle, ".concat("var(".concat(CSS_VAR_TEXT_COLOR, ")"), ")"))
    })
  }), children);
});